// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getProjectDetails } from "../services";
import { motion } from "framer-motion";
import { RichText } from "@graphcms/rich-text-react-renderer";

const ProjectDetail = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState([]);
  const slug = location.state;
  useEffect(() => {
    getProjectDetails(slug)
      .then(async (result) => {
        setProject(result);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      {loading ? (
        <div className="load flex items-center justify-center">
          <div className="w-16 h-16 border-4 border-white border-solid rounded-full animate-spin"></div>
        </div>
      ) : (
        <div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <section className="w-full h-full">
              <div className="px-10 lg:px-20 mt-10 pb-10 content-center">
                <h1 className="block text-center capitalized font-bold font-ailerons text-3xl border-b border-b-solid border-b-white pb-5">
                  {project.title}
                </h1>

                <div className="cut mt-10 p-4 lg:p-10 border border-solid border-white">
                  {project.content.raw && (
                    <React.Fragment>
                      <img
                        src={project.image.url}
                        alt={project.title}
                        className="mb-10 block m-auto border border-white"
                      />
                      <RichText
                        content={project.content.raw.children}
                        renderers={{
                          p: ({ children }) => (
                            <p className="mb-8">{children}</p>
                          ),
                          ul: ({ children }) => (
                            <ul className="mb-8 grid lg:grid-cols-2">
                              {children}
                            </ul>
                          ),
                          li: ({ children }) => (
                            <li className="mb-3 list-disc list-inside pl-5">
                              {children}
                            </li>
                          ),
                          h3: ({ children }) => (
                            <h3 className="text-xl font-semibold mb-4">
                              {children}
                            </h3>
                          ),
                          h4: ({ children }) => (
                            <h4 className="text-md font-semibold mb-4">
                              {children}
                            </h4>
                          ),
                          a: ({ children, href }) => (
                            <a href={href} target="blank">
                              {children}
                            </a>
                          ),
                        }}
                      />
                    </React.Fragment>
                  )}
                  <div className="text-center">
                    <a
                      href={project.liveLink}
                      target="blank"
                      className="block lg:inline-block lg:mr-5 text-blue-200"
                    >
                      Demo
                    </a>
                    <a
                      href={project.repo}
                      target="blank"
                      className="block lg:inline-block text-blue-200"
                    >
                      Project Repository
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default ProjectDetail;
